import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const updateEmployeeLeaveAllocation = createAsyncThunk(
  "employee/updateLeave",
  async (
    { employeeId, leaveTypeId, year, allocatedDays },
    { rejectWithValue },
  ) => {
    try {
      const response = await axios.post(`${API_URL}/leave/update-allocation`, {
        employeeId,
        leaveTypeId,
        year,
        allocatedDays,
      });
      return response.data;
    } catch (err) {
      const msg =
        err.response?.data?.message || "Failed to update leave allocation";
      return rejectWithValue(msg);
    }
  },
);

export const fetchEmployeeLeaveRequests = createAsyncThunk(
  "employee/fetchLeaveRequests",
  async ({ employeeId, leaveTypeId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/leave/${employeeId}`, {
        params: {
          ...(leaveTypeId && { leaveTypeId }),
        },
      });
      return response.data;
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        "Failed to fetch Employee Leave Requests";
      return rejectWithValue(msg);
    }
  },
);

export const fetchAllLeaveRequests = createAsyncThunk(
  "employee/fetchAllLeaveRequests",
  async ({ companyId, ...params } = {}, { rejectWithValue }) => {
    try {
      if (!companyId) {
        return rejectWithValue("Company ID is required");
      }
      console.log("params", params);
      const response = await axios.get(`${API_URL}/leave/company/${companyId}/hierarchy`, {
        params: {
          ...(params.page && { page: params.page }),
          ...(params.limit && { limit: params.limit }),
          ...(params.leaveTypeId && { leaveTypeId: params.leaveTypeId }),
          ...(params.status && params.status !== "All" && { status: params.status }),
          ...(params.branchId && { branchId: params.branchId }),
        },
      });
      console.log("api response", response.data);
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to fetch leave requests by hierarchy";
      return rejectWithValue(msg);
    }
  },
);

const employeeLeaveSlice = createSlice({
  name: "employeeLeave",
  initialState: {
    list: [],
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    status: "idle",
    error: null,
  },
  reducers: {
    clearAuditError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateEmployeeLeaveAllocation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateEmployeeLeaveAllocation.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateEmployeeLeaveAllocation.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchEmployeeLeaveRequests.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEmployeeLeaveRequests.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchEmployeeLeaveRequests.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchAllLeaveRequests.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllLeaveRequests.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Handling the structured response { data, meta }
        state.list = action.payload.data || [];
        state.totalItems = action.payload.meta?.total || 0;
        state.totalPages = action.payload.meta?.totalPages || 0;
        state.currentPage = action.payload.meta?.page || 1;
      })
      .addCase(fetchAllLeaveRequests.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearAuditError } = employeeLeaveSlice.actions;
export default employeeLeaveSlice.reducer;